import { map } from "ramda";
import {
  getMappedAccountsByPage,
  getUnmappedAccountsByPage,
  SpreadMappedAccountsByPage,
  SpreadUnmappedAccountsByPage
} from "../mappedUnmappedAccounts/mappedUnmappedAccountsByPage";
import {
  SpreadAccountRow,
  SpreadGroundPage,
  SpreadUnmappedAccount
} from "../spread/types";

export interface SpreadPagePresenter {
  spreadGroundPage: SpreadGroundPage;
  unmappedAccounts: SpreadUnmappedAccount[];
  mappedAccounts: SpreadAccountRow[];
}

export const pagePresenters = (
  spreadGroundPages: SpreadGroundPage[],
  unmappedAccountsByPage: SpreadUnmappedAccountsByPage,
  mappedAccountsByPage: SpreadMappedAccountsByPage
): SpreadPagePresenter[] =>
  map(
    spreadGroundPage => ({
      spreadGroundPage,
      unmappedAccounts: getUnmappedAccountsByPage(
        unmappedAccountsByPage,
        spreadGroundPage.pageNumber
      ),
      mappedAccounts: getMappedAccountsByPage(
        mappedAccountsByPage,
        spreadGroundPage.pageNumber
      )
    }),
    spreadGroundPages
  );



// WEBPACK FOOTER //
// ./src/spread/model/presenter/pagePresenters.ts